import React from 'react'

const e = React.createElement;


function Graph(props) {
  React.Component.constructor.call(this);

  this.state = {graph_offset:null};
}
Graph.prototype = Object.create(React.Component.prototype);


Graph.prototype.componentDidUpdate = function() {
  var canvas_wrapper = document.getElementById("graph-wrapper");
  var canvas = document.getElementById("canvas");
  if(this.state.graph_offset === null && canvas_wrapper && canvas && canvas.width > 0) {
    var max_width = canvas_wrapper.offsetWidth;
    var new_graph_offset = -(canvas.width - max_width);
    this.setState({graph_offset:new_graph_offset});
  }
}

Graph.prototype.render = function() {
  const data = this.props.data;
  const groups = this.props.groups ? this.props.groups : null;
  const filtered = this.props.filtered ? this.props.filtered : null;
  var canvas = document.getElementById("canvas");

  if(canvas && data[0] !== undefined) {
    var ctx = canvas.getContext("2d");
    var values = {};
    data.map(function(item, i) {
      if(filtered && item.app_id !== filtered) {return;}
      var d = new Date(item.created_on);
      var key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      if(groups) {
        if(values[key] === undefined) {
          values[key] = {};
          var is_rest = true;
          for(var group_label in groups) {
            values[key][group_label] = 0;
            if(item.app_id === group_label) {
              values[key][group_label] = 1;
              is_rest = false;
            }
          }
          if(is_rest) values[key]["rest"] = 1;
        } else {
          var is_rest = true;
          for(var group_label in groups) {
            if(item.app_id === group_label) {
              values[key][group_label] += 1;
              is_rest = false;
            }
          }
          if(is_rest) values[key]["rest"] += 1;
        }
      } else {
        if(values[key] === undefined) {
          values[key] = 1;
        } else {
          values[key]++;
        }
      }
    });

    var max_value = 0;
    if(groups) {
      for(var i in values) {
        var group_value = 0;
        for(var i2 in values[i]) {
          group_value += values[i][i2];
        }
        if(group_value > max_value) max_value = group_value;
      }
    } else {
      for(var i in values) {
        if(values[i] > max_value) max_value = values[i];
      }
    }

    var d = new Date(data[data.length - 1].created_on);
    var first_key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
    var d2 = new Date(data[0].created_on);
    var last_key = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();

    var dates = {};
    for(var loop_stop = 0; loop_stop < 1;) {
      var key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      dates[key] = 0;
      d.setDate(d.getDate() + 1);

      if(key === last_key) {
        loop_stop++;
      }
    }

    canvas.width = Object.keys(dates).length * 20 - 10;

    var dates_i = 0, months = [];
    for(var key in dates) {
      ctx.fillStyle = "#222222";
      if(values[key]) {
        if(groups) {
          var perc_offset = 0;
          for(var group_label in groups) {
            ctx.fillStyle = groups[group_label]+(key === last_key ? "99" : "");
            var perc = Math.floor(values[key][group_label] / max_value * 100);
            ctx.fillRect(0+dates_i*20, 100-perc-perc_offset, 10, perc);
            perc_offset += perc;
          }
          ctx.fillStyle = "#222222";
        } else {
          var perc = Math.floor(values[key] / max_value * 100);
          ctx.fillRect(0+dates_i*20, 100-perc, 10, perc);
        }
      }

      if(groups) {
        var group_value = 0;
        for(var group_i in values[key]) {
          group_value += values[key][group_i];
        }
        if(group_value === max_value) {
          ctx.beginPath(); // dot/point of max value in graph
          ctx.arc(5+dates_i*20, 94, 2, 0, 2 * Math.PI);
          ctx.fill();
        }
      } else {
        if(values[key] === max_value) {
          ctx.fillStyle = "#FF669E";
          ctx.beginPath(); // dot/point of max value in graph
          ctx.arc(5+dates_i*20, 94, 2, 0, 2 * Math.PI);
          ctx.fill();
          ctx.fillStyle = "#222222";
        }
      }

      var label = key.split("-");
      ctx.fillText(label[2], -1+dates_i*20, 110);

      if(months.indexOf(label[1]) === -1) {
        ctx.fillStyle = "#bbbbbb";
        ctx.fillText(label[1], 0+dates_i*20, 120);
        ctx.fillStyle = "#222222";
        months.push(label[1]);
      }

      dates_i++;
    }
  } else if(!canvas) {
    setTimeout(function() {
      this.setState({reload:true});
    }.bind(this), 0);
  }

  return e('div', {className:"card"}, e('div', {id:"graph-wrapper", style:{overflow:"hidden"}}, [
    e('span', {key:"left", className:"graph-arrow", onClick:this.moveGraph.bind(this, false)}, "<"),
    e('span', {key:"right", className:"graph-arrow", onClick:this.moveGraph.bind(this, true), style:{marginLeft:"22px"}}, ">"),
    e('span', {key:"max", style:{float:"right", fontSize:"62%", opacity:".4"}}, max_value && "max. "+max_value),
    e('canvas', {key:"canvas", id:"canvas", width:"0px", height:"120px", style:{marginLeft:this.state.graph_offset}})
  ]));
}

Graph.prototype.moveGraph = function(move_right) {
  var canvas_wrapper = document.getElementById("graph-wrapper");
  var max_width = canvas_wrapper.offsetWidth;
  var canvas = document.getElementById("canvas");

  var new_offset = -120;
  var new_graph_offset = this.state.graph_offset;
  if(canvas.width > 0) {
    if(!move_right && new_graph_offset < 0) {
      new_graph_offset = this.state.graph_offset - new_offset;
      if(new_graph_offset > 0) new_graph_offset = 0;
    }
    if(move_right && canvas.width + this.state.graph_offset > max_width) {
      new_graph_offset = this.state.graph_offset + new_offset;
      if(canvas.width + new_graph_offset < max_width) new_graph_offset = -(canvas.width - max_width);
    }
  }
  this.setState({graph_offset:new_graph_offset});
}


export default Graph



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Graph.js
// module id = 205
// module chunks = 0